module.exports = __webpack_public_path__ + "img/2015taiguo.f586a31a.png";